module.exports = __webpack_public_path__ + "img/png13.a67311b2.png";